/**
 * 請求管理 複写
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/deals`

const sales_deal_duplicate = {
  namespaced: true,
  actions: {
    /**
     * 複写元情報一覧
     * @param dispatch
     * @param commit
     * @param state
     * @param params { Object } 検索条件
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { params }) {
      const parameters = {
        ...params,
        duplicate: true,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: parameters }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 複写元情報の取得
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    new ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/duplicates/new`
        Vue.$http.get(api_path).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}
export default sales_deal_duplicate
